import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenField"]

  clear(event) {
    event.preventDefault()
    
    // Remove the hidden field from the DOM
    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.remove()
    }
    
    // Submit the form
    const form = this.element.closest("form")
    if (form) {
      form.requestSubmit()
    }
  }
}